import React, { Component } from "react";
import moment from "moment";
import { Row, Col, Table, Form, Image, Container } from "react-bootstrap";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import OpenIssuesUsersTableBody from "./OpenIssuesUsersTableBody";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_vendor_issues_suggestions,
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
} from "../../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
import { get_all_categories } from "../../../../store/actions/categoryActions";
import isEmpty from "../../../../store/validation/is-Empty";
import { SuggestionDropDownModelPopup } from "../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import Filter from "../../openIssuesVendor/Filter";

import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import Card from "react-bootstrap/Card";
import EditOpenIssuesVendor from "../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/InsideAllPageComponent/EditOpenIssuesVendor";
import NoContent from "../../../reusableComponents/NoContentComponent";

const totalRecordsInOnePage = 25;

export class InProcessOpenIssuesVendorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPagination: 1,
      open: false,
      status: "",
      allIssuesDetails: [],
      search: "",
      id: "",
      loader: false,
      allcategory: [],
      filterOpen: false,
      simpleClick: "All",
      statusFilter: "All",
      filterData:{}
    };
  }

  componentDidMount() {
    this.props.get_vendor_issues_suggestions(this.props.auth.user.accessToken);
    if (!isEmpty(this.props.get_all_categories)) {
      this.props.get_all_categories();
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.allIssuesSuggestion) !== nextState.allIssuesDetails &&
      !isEmpty(nextProps.allCategory) !== nextState.allcategory
    ) {
      let allNewIssuesSuggestion = nextProps.allIssuesSuggestion.filter(
        (notify) => notify.status === 1
      );
      return {
        allIssuesDetails: !isEmpty(allNewIssuesSuggestion)
          ? allNewIssuesSuggestion
          : [],
        allcategory: !isEmpty(nextProps.allCategory)
          ? nextProps.allCategory
          : [],
      };
    }
    if (!isEmpty(nextProps.auth.loader) !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
  }

  userTicketTextButtonClick = (e, type) => {
    this.setState({
      status: type,
    });
  };

  onSuccessSubmit = (issueId) => (e) => {
    if (this.state.status === "") {
      alert("Please select issue staus");
    } else {
      const token = this.props.auth.user.accessToken;
      const formData = {
        status: this.state.status,
      };
      this.props.comment_vendor_issues_suggestion(formData, token, issueId);
      this.userTicketClosed();
    }
  };

  /********************************************
   * @DESC FILTER MODAL FUNCTIONS
   ********************************************/
  onFilterOpen = (e) => {
    this.setState({
      filterOpen: true,
    });
  };

  onFilter = (data) => {
    this.setState({ filterData: data });
  }

  onFilterClosed = (e) => {
    this.setState({
      filterOpen: false,
    });
  };

  buttonClickHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      simpleClick: type,
    });
  };

  categoryButtonHandler = (data) => (e) => {
    this.setState({
      // statusFilter: data,
      simpleClick: data,
    });
  };

  resetFilterFunc = (e) => {
    this.setState({
      statusFilter: "All",
      simpleClick: "All",
      filterOpen: false,
    });
  };

  applyFilterFunc = (e) => {
    this.setState({
      statusFilter: this.state.simpleClick,
      filterOpen: false,
    });
  };

  /*********************************************
   * @DESC Reservation Table Around Time Model
   ********************************************/

  reservationTableAroundTimeOpen = (id) => (e) => {
    this.setState({
      open: true,
      id: id,
    });
  };

  reservationTableAroundTimeClosed = (e) => {
    this.setState({
      open: false,
    });
  };

  reservationTableAroundTimeTextButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      status: type,
      open: false,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  sendInformationViewIssues = (id) => (e) => {
    const issueId = id;
    const token = this.props.auth.user.accessToken;
    this.props.get_only_one_issues_suggestions(
      token,
      issueId,
      this.onSuccess(issueId)
    );
  };

  onSuccess = (issueId) => (e) => {
    this.props.history.push({
      pathname: `/viewticketvendoropensuggestionissues/${issueId}`,
      state: { issuesId: issueId },
    });
  };

  sendInformationEditTicket = (data) => (e) => {
    // console.log(data);
    this.props.history.push({
      pathname: "/editticketvendoropensuggestionissues",
      state: { issuesId: data._id },
    });
  };

  onChangePagination = (page) => {
    // console.log(page);
    this.setState({
      currentPagination: page,
    });
  };
  userTicketOpen = (id) => (e) => {
    this.setState({
      open: true,
      id: id,
    });
  };
  userTicketClosed = (e) => {
    this.setState({
      open: false,
    });
  };

  renderTableDataBody = () => {
    const { allIssuesDetails, currentPagination, filterData } = this.state;
    let filtereddata = [];
    if (this.state.statusFilter === "All") {
      filtereddata = allIssuesDetails;
      // filtereddata = allIssuesDetails.filter((notify) => notify.status === 1);
    } else if (this.state.statusFilter === this.state.simpleClick.toString()) {
      filtereddata = allIssuesDetails.filter(
        (notify) =>
          notify.category.category_name ===
            this.state.statusFilter.toString() && notify.status === 1
      );
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allIssuesDetails.filter((getall) => {
        if (search.test(getall.issue_id)) {
          return getall;
        } else if (search.test(getall.issue_title)) {
          return getall;
        } else if (search.test(getall.category.category_name)) {
          return getall;
        } else if (search.test(getall.comment)) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (filterData) {
      if (filterData?.start && filterData?.end) {
        filtereddata = filtereddata?.filter(ele => {
          if (moment(filterData?.start).toDate() < moment(ele?.createdAt).toDate() && moment(ele.createdAt).toDate() < moment(filterData?.end).endOf('day').toDate()) return true
          else return false;
        })
      }
      if(filterData?.category){
        filtereddata = filtereddata?.filter(ele => ele?.category?._id == filterData.category);
      }
      if(filterData?.type){
        filtereddata = filtereddata?.filter(ele => ele.type === filterData?.type)
      }
    }


    if (!isEmpty(filtereddata)) {
      return filtereddata.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              <OpenIssuesUsersTableBody
                issuesData={data}
                srno={++index}
                displayImage={true}
                // restaurantID={data.category.category_name}
                issuesTitle={data.issue_title}
                statusDropDownLink={this.userTicketOpen(data._id)}
                statusDropDownText={
                  data.status === 0
                    ? "New"
                    : data.status === 1
                    ? "In-Progress"
                    : data.status === 2
                    ? "Awaiting - Feedback"
                    : data.status === 3
                    ? "On-Hold"
                    : data.status === 4
                    ? "ReOpened"
                    : data.status === 5
                    ? "Resolved"
                    : data.status === 6
                    ? "Closed"
                    : data.status === 7
                    ? "Archive"
                    : data.status === 8
                    ? "Called User"
                    : data.status === 9
                    ? "Completed"
                    : ""
                }
                statusDropDown={
                  <SuggestionDropDownModelPopup
                    onOpenModal={this.userTicketOpen(data._id)}
                    open={this.state.open}
                    onCloseModal={this.userTicketClosed}
                    buttonTitle="Suggestion Status"
                    buttonText="Suggestion Status"
                    headerText="Suggestion Status"
                    displayButtonThree={true}
                    displayButtonFour={true}
                    displayButtonFive={true}
                    displayButtonSix={true}
                    status={this.state.status}
                    timeTextOne="New"
                    timeTextTwo="In-Progress"
                    timeTextThree="Awaiting - Feedback"
                    timeTextFour="On-Hold"
                    timeTextFive="ReOpened"
                    timeTextSix="Resolved"
                    timeTextSeven="Closed"
                    timeTextEight="Archive"
                    timeTextNine="Called User"
                    timeTextTen="Completed"
                    timeOneClick={(e) => this.userTicketTextButtonClick(e, 0)}
                    timeTwoClick={(e) => this.userTicketTextButtonClick(e, 1)}
                    timeThreeClick={(e) => this.userTicketTextButtonClick(e, 2)}
                    timeFourClick={(e) => this.userTicketTextButtonClick(e, 3)}
                    timeFiveClick={(e) => this.userTicketTextButtonClick(e, 4)}
                    timeSixClick={(e) => this.userTicketTextButtonClick(e, 5)}
                    timeSevenClick={(e) => this.userTicketTextButtonClick(e, 6)}
                    timeEightClick={(e) => this.userTicketTextButtonClick(e, 7)}
                    timeNineClick={(e) => this.userTicketTextButtonClick(e, 8)}
                    timeTenClick={(e) => this.userTicketTextButtonClick(e, 9)}
                    onSubmit={this.onSuccessSubmit(data._id)}
                  />
                }
                userImage={require("../../../../assets/images/superadmin/macd.png")}
                userName="Akhil Sharma"
                issuesDate={moment(data.createdAt).format("DD/MM/YYYY")}
                viewTicket={this.sendInformationViewIssues(data._id)}
                editTicket={this.sendInformationEditTicket(data)}
              />
            </React.Fragment>
          )
      );
    } else {
      return <NoContent/>;
    }
  };

  renderOpenIssuesAccordian = () => {
    const { allIssuesDetails, currentPagination, show } = this.state;
    let filtereddata = [];
    if (this.state.statusFilter === "All") {
      filtereddata = allIssuesDetails;
      filtereddata = allIssuesDetails.filter((notify) => notify.status === 1);
    } else if (this.state.statusFilter === this.state.simpleClick.toString()) {
      filtereddata = allIssuesDetails.filter(
        (notify) =>
          notify.category.category_name ===
            this.state.statusFilter.toString() && notify.status === 1
      );
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allIssuesDetails.filter((getall) => {
        if (search.test(getall.issue_id)) {
          return getall;
        } else if (search.test(getall.issue_title)) {
          return getall;
        } else if (search.test(getall.category.category_name)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment>
              <SwipeableList className={`swipeOffer`}>
                {({ swipeOffer, ...rest }) => (
                  <div className={`${show ? "swipeOffer" : ""}`}>
                    <SwipeableListItem
                      swipeLeft={{
                        content: (
                          <div className="d-flex swipeOption">
                            <button
                              type="button"
                              className="n_button_d_status font_18_m "
                              style={{ backgroundColor: "white" }}
                            ></button>
                            <button
                              type="button"
                              className="n_button_d_status font_18_m popup-cancel-button"
                              onClick={(e) =>
                                this.sendInformationViewIssues(data._id)
                              }
                            >
                              <div>
                                <i
                                  style={{ color: "#ffffff" }}
                                  class="fa fa-eye"
                                  aria-hidden="true"
                                ></i>
                                <br />
                                View
                              </div>
                            </button>
                            <EditOpenIssuesVendor />
                          </div>
                        ),
                        action: () => this.setState({ show: true }),
                      }}
                      swipeRight={{
                        // content: <div>Revealed content during swipe</div>,
                        action: () => this.setState({ show: false }),
                      }}
                      {...rest}
                    >
                      <Card className="main-reusable-accordion">
                        <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                          <div className="d-flex align-items-center">
                            <div
                              className="card-header-left f10-500"
                              style={{ width: "25%" }}
                            >
                              #{++index}
                            </div>
                            <div
                              className="card-header-middle f10-500"
                              style={{ width: "33.3333%" }}
                            >
                              {data.issue_title}
                            </div>
                            <div
                              className="card-header-middle f10-500"
                              style={{ width: "25%", textAlign: "center" }}
                            >
                              {data && data.category && data.category.title}
                            </div>
                            <div
                              className="card-header-right f10-500 justify-content-end"
                              style={{ width: "16.666%" }}
                            >
                              {data.status === 0
                                ? "New"
                                : data.status === 1
                                ? "In-Progress"
                                : data.status === 2
                                ? "Awaiting - Feedback"
                                : data.status === 3
                                ? "On-Hold"
                                : data.status === 4
                                ? "ReOpened"
                                : data.status === 5
                                ? "Resolved"
                                : data.status === 6
                                ? "Closed"
                                : data.status === 7
                                ? "Archive"
                                : data.status === 8
                                ? "Called User"
                                : data.status === 9
                                ? "Completed"
                                : ""}
                            </div>
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={index}>
                          <Card.Body>
                            {/******* Section One *********/}
                            <hr className="mt-0" />
                            <Container fluid>
                              <Row>
                                <Col xs={4} className="p-0">
                                  <div className="f10-500">Ticket Date</div>
                                  <div className="f10-400">
                                    {moment(new Date()).format("DD/MM/YYYY")}
                                  </div>
                                </Col>
                                <Col xs={5} className="p-0">
                                  <div className="f10-500">User Name</div>
                                  <div className="d-flex align-items-center">
                                    <div className="enIMG33 rounded-circle mr-2">
                                      <Image
                                        fluid
                                        src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                        alt="Icon"
                                      />
                                    </div>
                                    <div className="f10-400">Akhil Sharma</div>
                                  </div>
                                </Col>
                                <Col xs={3} className="p-0">
                                  <div className="f10-500">Order Type</div>
                                  <div className="d-flex align-items-center">
                                    <div className="image-box-new mr-2">
                                      <Image
                                        fluid
                                        width="20px"
                                        src={require("../../../../assets/images/seatingImages/reservationBlack.png")}
                                      />
                                    </div>
                                    {/* <div>
                                      <div className="f10-400">Reservation</div>
                                    </div> */}
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </SwipeableListItem>
                  </div>
                )}
              </SwipeableList>
            </React.Fragment>
          )
      );
    } else {
      return <NoContent/>;
    }
  };
  render() {
    if (this.props.auth.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Row className="align-items-center pt-4">
          <Col className="col-auto seating-topbar-search">
            <div className="filter-button">
              <Filter onFilter={this.onFilter} />
            </div>
          </Col>
          <Col md={4}>
            <Form.Control
              type="search"
              name="search"
              placeholder="Search"
              className="amSearch"
              value={this.state.search}
              onChange={this.onSearchChange}
            />
          </Col>
        </Row>
        <Media query="(max-width: 991px)">
          <>
            <div className="row seating-dashboard-table">
              <div className="col-3 mpr-1">
                <p className="f12-700 pl-3">
                  Issue ID/
                  <br />
                  Issue No
                </p>
              </div>
              <div className="col-4 mpl-1 mpr-1">
                <p className="f12-700">Title</p>
              </div>
              <div className="col-3 mpl-1">
                <p className="f12-700">Category</p>
              </div>
              <div className="col-2 mpl-1">
                <p className="f12-700">Status</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-0">
                <Accordion>{this.renderOpenIssuesAccordian()}</Accordion>
              </div>
            </div>
          </>
        </Media>
        <Media query="(min-width: 991px)">
          <div className="user-table-reusable-superadmin table-responsive">
            <Table className="enMinWidth900">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th className="f12-700" style={{ width: "10%" }}>
                    Issue ID/
                    <br />
                    Issue No
                  </th>
                  <th className="f12-700" style={{ width: "16%" }}>
                    Title
                  </th>
                  <th className="f12-700" style={{ width: "10%" }}>
                    Status
                  </th>
                  <th className="f12-700" style={{ width: "12%" }}>
                    Category
                  </th>
                  <th className="f12-700" style={{ width: "20%" }}>
                    Description
                  </th>
                  <th className="f12-700" style={{ width: "10%" }}>
                    Issues/
                    <br />
                    Suggestion
                  </th>
                  <th className="f12-700" style={{ width: "10%" }}>
                    Issue Date/
                    <br />
                    Time
                  </th>
                  <th className="f12-700" style={{ width: "12%" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              {this.renderTableDataBody()}
            </Table>
          </div>
        </Media>
        <div className="p4v2-menu-pagination">
          <Pagination
            onChange={this.onChangePagination}
            current={this.state.currentPagination}
            defaultPageSize={totalRecordsInOnePage}
            total={
              !isEmpty(this.state.allIssuesDetails)
                ? this.state.allIssuesDetails.length
                : 0
            }
            showTitle={false}
          />
        </div>
      </React.Fragment>
    );
  }
}

InProcessOpenIssuesVendorDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allIssuesSuggestion:
    state.vendorIssuesSuggestion.vendor_all_issues_suggestion,
  allCategory: state.categories.get_all_categories,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_issues_suggestions,
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
  get_all_categories,
})(withRouter(InProcessOpenIssuesVendorDashboard));
